<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'


const playerFlagsStore = usePlayerFlagsStore()

const handleNextStep = async () => {
  await handleNext('tutorial_spy_end')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/spy.webm"
  >
    <template #text>
      <p class="pb-2">
        Using spies against other empires can be hugely beneficial or have dire consequences.
      </p>
      <p class="pb-2">
        Your spies can be killed when on offensive missions, and there is also a chance that your target will find out it was your spy. Which could lead to an diplomatic incident.
      </p>
      <p class="pb-2">
        Always balance the risk versus reward, and remember - your enemies are likely spying on you too!
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Got it
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>